import { render, staticRenderFns } from "./InfosComp.vue?vue&type=template&id=ccbe0c1e&scoped=true&"
import script from "./InfosComp.vue?vue&type=script&lang=js&"
export * from "./InfosComp.vue?vue&type=script&lang=js&"
import style0 from "./InfosComp.vue?vue&type=style&index=0&id=ccbe0c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbe0c1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
